import { useField } from "formik";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

export default function DRxInput(props: any) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);

  return (
    <>
      <TextField
        type="text"
        error={meta.touched && meta.error}
        {...field}
        {...rest}
      />
      {meta.error && (
        <>
          {" "}
          <Typography
            color="error"
            className="error"
            variant="body2"
            component="div"
          >
            {meta.error}
          </Typography>
        </>
      )}{" "}
    </>
  );
}
